// Dialog Components (only export components, not interfaces)
export { SearchExportDialogComponent } from "./search-export/search-export-dialog.component";
export { SearchGeofencingDialogComponent } from "./search-geofencing/search-geofencing-dialog.component";
export { GeofencingChangeWarningDialogComponent } from "./search-geofencing/geofencing-change-warning-dialog.component";
export { SearchImageDialogComponent } from "./search-image/search-image-dialog.component";

// Re-export enums and interfaces from centralized model location
export {
  // Image Search
  ImageSearchMethod,
  ImageSearchDialogConfig,
  ImageSearchDialogResult,

  // Geofencing
  GeometryInputMethod,
  GeometryType,
  GeofencingDialogConfig,
  GeofencingDialogResult,
  GeofencingFilter,

  // Export
  ExportConfig,
  ExportResult,
  ExportFormat,
  ExportProgress,
  SearchQueryDisplay,
} from "../model/dialogs";
